import React from "react";
import { BsCaretLeft, BsCaretRight } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import DisplayThumbnail from "../thumbnailForPDF/displayThumbnail";

type ZoomChatImageProps = {
  image: string[];
  setShowAllImages: (value: React.SetStateAction<number | null>) => void;
  currentIndex: number;
  handlePrev: () => void;
  handleNext: () => void;
  totalImages: number;
  fileUrls?: string[];
  margin?: string;
};
const ZoomChatImage: React.FC<ZoomChatImageProps> = ({
  image,
  currentIndex,
  setShowAllImages,
  handlePrev,
  handleNext,
  totalImages,
  fileUrls,
  margin,
}) => {
  const isPDFFile =
    image[currentIndex].includes("ecobookFiles") ||
    image[currentIndex].includes("ecomotoFiles");
  const defaultMargin = margin === 'ecobookChat' ? 63 : 100;
  return (
    <div
      className={`picModal bg-black fixed inset-0 h-[calc(100%-${defaultMargin}px)] mt-[${defaultMargin}px] py-10 z-30 justify-center overflow-y-hidden items-center flex`}
    >
      <div className="p-4 flex w-[90%] items-center h-[90%] justify-center">
        {isPDFFile ? (
          <div className="w-full h-full">
            <DisplayThumbnail fileUrl={image[currentIndex]} pageIndex={1} />
          </div>
        ) : (
          <img
            src={image[currentIndex]}
            alt=""
            className="w-auto max-w-lg h-auto max-h-[90%]"
          />
        )}
      </div>
      <div className="flex gap-3 absolute top-1 left-1 items-center justify-center">
        <button className="cursor-pointer h-10 w-10 items-center justify-center flex rounded-full">
          <IoMdClose
            size={33}
            className="cursor-pointer text-white"
            onClick={() => setShowAllImages(null)}
          />
        </button>
        <img src="/logo.png" alt="" className="w-10 h-10" />
      </div>

      {image.length > 1 && (
        <>
          <button
            onClick={handlePrev}
            disabled={currentIndex === 0}
            className="fixed top-[50%] cursor-pointer left-1 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey"
          >
            <BsCaretLeft size={35} className="cursor-pointer" />
          </button>
          <button
            onClick={handleNext}
            disabled={currentIndex === totalImages - 1}
            className="fixed top-[50%]  cursor-pointer right-1 h-10 w-10 items-center justify-center bg-white flex rounded-full disabled:bg-CoolGrey "
          >
            <BsCaretRight size={35} className="cursor-pointer" />
          </button>
        </>
      )}
    </div>
  );
};

export default ZoomChatImage;
